import types from './types';
import {authTypes} from '../auth';
import {initialState} from '../../../App';

const card = (state = {}, action) => {
  switch (action.type) {
    case authTypes.CLEAR: {
      return {
        ...state, ...initialState.card,
      };
    }
    case types.START_FETCH: {
      return {
        ...state,
        loading: true,
      };
    }
    case types.END_FETCH: {
      const {error, payload} = action;
      return {
        ...state,
        loading: false,
        error: error ? payload : null,
      };
    }
    case types.UPDATE_CARD_DATA: {
      const {
        card, person, address, transactions: transactionData,
      } = action.payload;

      return {
        ...state,
        card,
        person,
        address,
        transactions: transactionData,
      };
    }
    default:
      return state;
  }
};

export default card;
